import { dispatch } from 'nike-re-framejs';
import i18n from '../../common/i18n';

export function dispatchUploadProgress(uploadContext, progress, delay) {
    function task() {
        dispatch(setUploadProgress(uploadContext, progress));
    }
    if (delay) {
        setTimeout(task, delay);
    } else {
        task();
    }
    return uploadContext;
}

function setUploadProgress(uploadContext, progress) {
    return db => {
        const { slot, idDocDms, page } = uploadContext.get('slotDescription');
        const uploadData = { progress: progress > 100 ? 100 : progress, done: progress > 100 };
        uploadData.resolvedType = uploadContext.get('resolvedType');
        uploadData.filename = uploadContext.get('filename');
        if (uploadData.resolvedType === 'image') {
            uploadData.imageUrl = uploadContext.getIn(['image', 'resized']).url;
        }
        return db.mergeIn(['dms', 'model', 'docs', slot, idDocDms, 'files', page, 'upload'], uploadData);
    };
}

export function setUploadError(uploadContext, errorText) {
    return db => {
        const { slot, idDocDms, page } = uploadContext.get('slotDescription');
        return db.setIn(
            ['dms', 'model', 'docs', slot, idDocDms, 'files', page, 'upload', 'error'],
            errorText ? errorText : i18n('nui.documentUpload.uploadError')
        );
    };
}

export function setVersion(uploadContext, version) {
    return db => {
        const { slot, idDocDms, page } = uploadContext.get('slotDescription');
        return db.setIn(['dms', 'model', 'docs', slot, idDocDms, 'files', page, 'version'], version);
    };
}
